import React, { useEffect } from 'react';
import Router from './routers';
import ToastProvider from 'context/ToastContext';
import { UserDetailsProvider } from 'context/userDetailsContext';
import { TempStorageProvider } from 'context/tempStorageContext';
import { OutLookProvider } from 'context/OutlookContext';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { outlookConfig } from 'config/calendar_config.js';
import { WebSocketContextProvider } from 'context/WebSocketConnectionContext';
import { NavBarContextProvider } from 'context/NavbarContext';
import { LoaderContext } from 'context/LoaderContext.jsx';
import { Helmet } from 'react-helmet-async';
import { DataProvider } from 'context/DataProviderContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'config/queryClient';

const env = process.env.REACT_APP_ENV; // Read environment variable

const robotsValue = env === 'qa' || env === 'staging' || env === 'dev' ? 'noindex, nofollow' : 'index, follow';

function App() {
  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: outlookConfig.appId,
      redirectUri: outlookConfig.redirectUri,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
  });
  const accounts = msalInstance.getAllAccounts();
  if (accounts && accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      // Set the active account - this simplifies token acquisition
      const authResult = event.payload;
      msalInstance.setActiveAccount(authResult.account);
    }
  });

  useEffect(() => {
    let redirect_url = window.location.hash;
    redirect_url = redirect_url?.split('#')?.length >= 2 ? redirect_url?.split('#')?.[1] : null;
    if (redirect_url && redirect_url !== '/login') {
      // setValueInCookies('redirect_url', redirect_url);
    }

    (() => {
      const isTouch = navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

      document.documentElement.classList.toggle('touch-device', isTouch);
    })();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content={robotsValue} />
      </Helmet>

      <QueryClientProvider client={queryClient}>
        <LoaderContext>
          <UserDetailsProvider>
            <DataProvider>
              <ToastProvider>
                <WebSocketContextProvider>
                  <NavBarContextProvider>
                    <MsalProvider instance={msalInstance}>
                      <OutLookProvider>
                        <TempStorageProvider>
                          {/* <GlobalLoader /> */}
                          <Router />
                        </TempStorageProvider>
                      </OutLookProvider>
                    </MsalProvider>
                  </NavBarContextProvider>
                </WebSocketContextProvider>
              </ToastProvider>
            </DataProvider>
          </UserDetailsProvider>
        </LoaderContext>
        {/* React Query DevTools - only in development */}
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </>
  );
}

export default App;
